import React, { createContext, useContext, useState } from 'react';

/** context */
import { UserContext } from '../context/UserContext';

const FormContext = createContext();

export const FormProvider = ({ children }) => {
  let { profile } = useContext(UserContext);

  const fileFilterOptions = ['All', 'REQUESTED', 'SUBMITTED'];
  const [fileFilter, setFileFilter] = useState('All');

  const getPropertyFields = (feature, formData, values, fieldName, isUpdateValue) => {
    const fields = [];
    if (feature && feature.format) {
      for (const key of Object.keys(feature.format)) {
        fields.push({
          name: key,
          ...feature.format[key],
          fileType: feature.itemType === 'FileProperty' ? key : undefined,
        });
      }
    }

    if (feature && feature.conditionalFormats) {
      for (const key of Object.keys(feature.conditionalFormats)) {
        let conditionMatch = false;
        let cpt = 0;
        while (conditionMatch == false && cpt < feature.conditionalFormats[key].length) {
          let conditionalField = feature.conditionalFormats[key][cpt];

          let fieldConditionResult = false;

          if (conditionalField.condition) {
            if (conditionalField.condition.fields) {
              let fieldOrCpt = 0;
              while (
                fieldOrCpt < conditionalField.condition.fields.length &&
                fieldConditionResult == false
              ) {
                let fieldAndCpt = 0;
                let isMatch = true;

                while (
                  fieldAndCpt < conditionalField.condition.fields[fieldOrCpt].length &&
                  isMatch == true
                ) {
                  const f = conditionalField.condition.fields[fieldOrCpt][fieldAndCpt];
                  if (formData[f.fieldName]?.toString() != f.fieldPattern?.toString()) {
                    isMatch = false;
                  }

                  if (isUpdateValue && f.fieldName === fieldName) {
                    return {
                      newValues: { ...values, [key]: '' },
                      isUpdatedValue: true,
                    };
                  }
                  fieldAndCpt++;
                }
                if (isMatch) {
                  fieldConditionResult = true;
                }

                fieldOrCpt++;
              }
            } else if (conditionalField?.condition?.jwt?.length) {
              for (
                let fieldCpt = 0;
                fieldConditionResult == false && fieldCpt < conditionalField?.condition.jwt?.length;
                fieldCpt += 1
              ) {
                if (
                  conditionalField.condition.jwt[fieldCpt].matchType === 'FIELD' &&
                  formData[conditionalField.condition.jwt[fieldCpt].fieldName] ==
                    profile[conditionalField.condition.jwt[fieldCpt].jwtField.toLowerCase()]
                ) {
                  fieldConditionResult = true;
                }
              }
            } else if (conditionalField?.condition?.role?.length) {
              fieldConditionResult = false;
            } else {
              fieldConditionResult = true;
            }
            if (fieldConditionResult) {
              fields.push({ name: key, ...conditionalField.format });
              conditionMatch = true;
            }
          }
          cpt++;
        }
      }
    }
    //we duplicate the existing fields so we can compare & edit
    let existingFields = JSON.parse(JSON.stringify(fields));
    //map value to format object for files (for the ones that don't exist under format, but exist under value)
    if (feature?.itemType === 'FileProperty' && feature.value) {
      for (let cpt = 0; cpt < feature.value.length; cpt += 1) {
        //we check to match value on existing files form format object
        //we check of fileType since format object does not have fileName
        const fieldFound = existingFields.find(
          (field) => field.fileType == feature.value[cpt].fileType
        );
        if (fieldFound) {
          continue;
        }
        let format = {
          ...feature.value[cpt],
          label: feature.value[cpt].fileName,
          name: feature.value[cpt].fileName,
          type: 'file',
          inviteeFile: true,
        };
        fields.push({ ...format });
      }
    }
    return fields;
  };

  return (
    <FormContext.Provider
      value={{
        getPropertyFields,
        fileFilterOptions,
        fileFilter,
        setFileFilter,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useForm = () => {
  const { getPropertyFields, fileFilterOptions, fileFilter, setFileFilter } =
    useContext(FormContext);

  return {
    getPropertyFields,
    fileFilterOptions,
    fileFilter,
    setFileFilter,
  };
};
